import {Helmet} from "react-helmet";
import {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import ProductVariantBasicInfo from "../productVariantBasicInfo/ProductVariantBasicInfo";
import ProductVariantSku from "../productVariantSku/ProductVariantSku";
import ProductVariantEnabled from "../productVariantEnabled/ProductVariantEnabled";
import ProductVariantDefault from "../productVariantDefault/ProductVariantDefault";

export default function ProductVariantDetails() {

    const {id: variantId = -1} = useParams()


    const {state} = useLocation()
    const [variantTitle, setVariantTitle] = useState(state && state.title ? state.title : RouteHelper.ProductVariantDetails.name)
    const [tabSelectedValue, setTabSelectedValue] = useState(tabTypes.basicInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title>{variantTitle}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.ProductVariant.name,
                                RouteHelper.ProductVariant.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                variantTitle,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={tabTypes.basicInfo.title}
                                    value={tabTypes.basicInfo.id}/>
                                <Tab
                                    label={tabTypes.sku.title}
                                    value={tabTypes.sku.id}/>
                                <Tab
                                    label={tabTypes.default.title}
                                    value={tabTypes.default.id}/>
                                <Tab
                                    label={tabTypes.enabled.title}
                                    value={tabTypes.enabled.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={tabTypes.basicInfo.id}>
                            <ProductVariantBasicInfo variantId={variantId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.sku.id}>
                            <ProductVariantSku variantId={variantId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.default.id}>
                            <ProductVariantDefault variantId={variantId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.enabled.id}>
                            <ProductVariantEnabled variantId={variantId}/>
                        </TabPanel>

                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const tabTypes = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    sku: {
        id: "sku",
        title: "شناسه محصول"
    },
    default: {
        id: "default",
        title: "پیش فرض"
    },
    enabled: {
        id: "enabled",
        title: "انتشار",
    },
}